// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgExpandLeftLine = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="m10.071 4.93 1.414 1.413L6.828 11H16v2H6.828l4.657 4.657-1.414 1.414L3 12.001zM18.001 19V5h2v14z"
    />
  </svg>
);
export const ExpandLeftLineIcon = forwardRef(SvgExpandLeftLine);
